let mapper_options = {
  endpoint: 'facebook_pages',
  recordClass: require('./record'),
  relations: {
    hasMany: {
      retailer: {
        localKeys: 'retailer_ids',
        localField: 'retailers'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('facebook_page', mapper_options)
}
